import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';
import {
    USER_SOURCE_LDAP,
    USER_SOURCE_NG1,
    USER_SOURCE_SAML,
    USER_SOURCE_LOCAL_CAC,
    USER_SOURCE_LDAP_CAC,
} from '../users/UserConstants';

export const SELECTED_AUTH_TYPE_FIELD = 'selectedAuthType';

export const LDAP_FIELD = 'ldap';
export const LDAP_ENABLED_FIELD = 'ldap.enabled';
export const LDAP_OFFLINE_LOGIN_ENABLED_FIELD = 'ldap.offlineLoginEnabled';
export const LDAP_SERVER_FIELD = 'ldap.server';
export const LDAP_PORT_FIELD = 'ldap.port';
export const LDAP_SECURE_FIELD = 'ldap.secure';
export const LDAP_ANONYMOUS_FIELD = 'ldap.anonymous';
export const LDAP_BIND_DN_FIELD = 'ldap.bindDN';
export const LDAP_ENCRYPTED_BIND_CREDENTIALS_FIELD = 'ldap.encryptedBindCredentials.value';
export const LDAP_USER_SEARCH_BASE_FIELD = 'ldap.userSearchBase';
export const LDAP_USER_USERNAME_ATTR_FIELD = 'ldap.userUsernameAttr';
export const LDAP_USER_EMAIL_ADDRESS_ATTR_FIELD = 'ldap.userEmailAddressAttr';
export const LDAP_USER_FIRST_NAME_ATTR_FIELD = 'ldap.userFirstNameAttr';
export const LDAP_TLS_REJECT_UNAUTHORIZED_FIELD = 'ldap.tlsRejectUnauthorized';
export const LDAP_DEFAULT_ROLE_FIELD = 'ldap.defaultRole';
export const LDAP_GROUP_ROLE_ASSOCIATIONS_FIELD = 'ldap.groupRoleAssociations';
export const TEST_USERNAME_FIELD = 'ldap.testUser.username';
export const TEST_PASSWORD_FIELD = 'ldap.testUser.password';

export const SAML_FIELD = 'saml';
export const SAML_ENABLED_FIELD = 'saml.enabled';
export const SAML_PROVIDER_FIELD = 'saml.provider';
export const SAML_METADATA_FIELD = 'saml.metadata.value';
export const SAML_METADATA_ERROR_FIELD = 'saml.metadata';
export const SAML_USER_FIRST_NAME_ATTR_FIELD = 'saml.userFirstNameAttr';
export const SAML_USER_LAST_NAME_ATTR_FIELD = 'saml.userLastNameAttr';
export const SAML_USER_USERNAME_ATTR_FIELD = 'saml.userUsernameAttr';
export const SAML_USER_EMAIL_ADDRESS_ATTR_FIELD = 'saml.userEmailAddressAttr';
export const SAML_GROUP_USER_MEMBERSHIP_ATTR_FIELD = 'saml.groupUserMembershipAttr';
export const SAML_DEFAULT_ROLE_FIELD = 'saml.defaultRole';
export const SAML_GROUP_ROLE_ASSOCIATIONS_FIELD = 'saml.groupRoleAssociations';

export const CAC_LOCAL_FIELD = 'cac_local';
export const CAC_LOCAL_ENABLED_FIELD = 'cac_local.enabled';
export const CAC_LDAP_FIELD = 'cac_ldap';
export const CAC_LDAP_ENABLED_FIELD = 'cac_ldap.enabled';
export const CAC_LDAP_OFFLINE_LOGIN_ENABLED_FIELD = 'cac_ldap.offlineLoginEnabled';
export const CAC_LDAP_SERVER_FIELD = 'cac_ldap.server';
export const CAC_LDAP_PORT_FIELD = 'cac_ldap.port';
export const CAC_LDAP_SECURE_FIELD = 'cac_ldap.secure';
export const CAC_LDAP_ANONYMOUS_FIELD = 'cac_ldap.anonymous';
export const CAC_LDAP_INEXACT_FIELD = 'cac_ldap.inexactMatch';
export const CAC_LDAP_BIND_DN_FIELD = 'cac_ldap.bindDN';
export const CAC_LDAP_ENCRYPTED_BIND_CREDENTIALS_FIELD = 'cac_ldap.encryptedBindCredentials.value';
export const CAC_LDAP_USER_SEARCH_BASE_FIELD = 'cac_ldap.userSearchBase';
export const CAC_LDAP_USER_USERNAME_ATTR_FIELD = 'cac_ldap.userUsernameAttr';
export const CAC_LDAP_USER_EMAIL_ADDRESS_ATTR_FIELD = 'cac_ldap.userEmailAddressAttr';
export const CAC_LDAP_USER_FIRST_NAME_ATTR_FIELD = 'cac_ldap.userFirstNameAttr';
export const CAC_LDAP_TLS_REJECT_UNAUTHORIZED_FIELD = 'cac_ldap.tlsRejectUnauthorized';
export const CAC_LDAP_DEFAULT_ROLE_FIELD = 'cac_ldap.defaultRole';
export const CAC_LDAP_GROUP_ROLE_ASSOCIATIONS_FIELD = 'cac_ldap.groupRoleAssociations';
export const CAC_LDAP_USER_SEARCH_FILTER_ATTR_FIELD = 'cac_ldap.userSearchFilter';
export const CAC_LDAP_REVOCATION_METHOD = 'cac_ldap.revocation.method';
export const CAC_LDAP_REVOCATION_RESPONDER = 'cac_ldap.revocation.responder';
export const CAC_LDAP_REVOCATION_RESOLVER = 'cac_ldap.revocation.resolver';

export const EXACT_LDAP_SEARCH_FILTER = '({{userUsernameAttr}}={{username}})';
export const INEXACT_LDAP_SEARCH_FILTER = '({{userUsernameAttr}}=*{{username}}*)';

export const CAC_LDAP_REVOCATION_METHOD_NONE = 'None';
export const CAC_LDAP_REVOCATION_METHOD_OCSP = 'OCSP';
export const CAC_LDAP_REVOCATION_METHOD_CRL = 'CRL';
export const CAC_LDAP_REVOCATION_METHOD_NONE_KEY = 'none';
export const CAC_LDAP_REVOCATION_METHOD_OCSP_KEY = 'ocsp';
export const CAC_LDAP_REVOCATION_METHOD_CRL_KEY = 'crl';

export const GROUP_NAME_FIELD = 'groupName';
export const ASSOCIATED_ROLE_FIELD = 'associatedRole';

export const USER_SOURCE_LDAP_TEXT = 'Active Directory';
export const USER_SOURCE_SAML_TEXT = 'SAML SSO';
export const USER_SOURCE_NG1_TEXT = 'None';
export const USER_SOURCE_CAC_LOCAL_TEXT = 'CAC Local';
export const USER_SOURCE_CAC_LDAP_TEXT = 'CAC Active Directory';

export const ACTIVE_DIRECTORY_GROUP_LABEL = t`Active Directory Group`;
export const SAML_GROUP_LABEL = t`SAML Group`;

export const USER_SOURCE_OPTIONS = {
    [USER_SOURCE_NG1]: USER_SOURCE_NG1_TEXT,
    [USER_SOURCE_LDAP]: USER_SOURCE_LDAP_TEXT,
    [USER_SOURCE_SAML]: USER_SOURCE_SAML_TEXT,
    [USER_SOURCE_LOCAL_CAC]: USER_SOURCE_CAC_LOCAL_TEXT,
    [USER_SOURCE_LDAP_CAC]: USER_SOURCE_CAC_LDAP_TEXT,
};

export const UNAUTHORIZED_OPTION_TEXT = i18n._(t`Unauthorized`);
export const UNAUTHORIZED_OPTION_VALUE = 'UNAUTHORIZED';

export const LDAP_STATUS_UNKNOWN = 'unknown';
export const LDAP_STATUS_SUCCESS = 'success';
export const LDAP_STATUS_FAIL = 'fail';

export const LDAP_TEST_STATUSES = [
    {
        name: 'connect',
        title: i18n._(t`Connect to Active Directory server`),
        assocErrors: ['LDAP_FIND_CONNECTION_FAILED'],
        status: LDAP_STATUS_UNKNOWN,
    },
    {
        name: 'bind',
        title: i18n._(t`Bind to Active Directory server`),
        assocErrors: ['LDAP_BIND_CREDENTIALS_FAILED', 'LDAP_QUERY_FAILED'],
        status: LDAP_STATUS_UNKNOWN,
    },
    {
        name: 'findUser',
        title: i18n._(t`Search for user`),
        assocErrors: ['LDAP_NO_USER_FOUND'],
        status: LDAP_STATUS_UNKNOWN,
    },
    {
        name: 'authUser',
        title: i18n._(t`Authenticate user`),
        assocErrors: ['LDAP_USER_BAD_CREDS'],
        status: LDAP_STATUS_UNKNOWN,
    },
];
